import {
  type VirtualAssistantChatPanelState,
  VirtualAssistantHostContextProvider,
} from '@shinetools/virtual-assistant-client'
import { ReactElement, ReactNode, useMemo } from 'react'

import { useVirtualAssistantHostConfig } from '../../hooks/useVirtualAssistantHostConfig'

interface VirtualAssistantHostProps {
  children: ReactNode
  onChatPanelChange?: (state: VirtualAssistantChatPanelState) => void
}

export const VirtualAssistantHost = ({ children, onChatPanelChange }: VirtualAssistantHostProps): ReactElement => {
  const hostConfig = useVirtualAssistantHostConfig()
  const config = useMemo(() => ({ ...hostConfig, onChatPanelChange }), [hostConfig, onChatPanelChange])

  return <VirtualAssistantHostContextProvider config={config}>{children}</VirtualAssistantHostContextProvider>
}
